"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInteractionChannel = void 0;
const topic_1 = require("../../topic");
const USER_INTERACTION_CHANNEL = 'userinteraction';
class UserInteractionChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = USER_INTERACTION_CHANNEL;
        this.topics = {
            Regulation_Click: new topic_1.Topic('Regulation_Click', USER_INTERACTION_CHANNEL, this._logger),
            oddsFormatUpdate: new topic_1.Topic('oddsFormatUpdate', USER_INTERACTION_CHANNEL, this._logger),
            BurgerMenu_Toggle: new topic_1.Topic('BurgerMenu_Toggle', USER_INTERACTION_CHANNEL, this._logger),
            postRegistrationDepositClosed: new topic_1.Topic('postRegistrationDepositClosed', USER_INTERACTION_CHANNEL, this._logger),
            themeModeUpdate: new topic_1.Topic('themeModeUpdate', USER_INTERACTION_CHANNEL, this._logger),
            clientStateChanged: new topic_1.Topic('clientStateChanged', USER_INTERACTION_CHANNEL, this._logger),
            hapticFeedback: new topic_1.Topic("hapticFeedback", USER_INTERACTION_CHANNEL, this._logger),
            azSportsToggle: new topic_1.Topic('azSportsToggle', USER_INTERACTION_CHANNEL, this._logger)
        };
    }
}
exports.UserInteractionChannel = UserInteractionChannel;
//# sourceMappingURL=user-interaction.channel.js.map